export const appTranslations = {
  en: () =>
    import(/* webpackPrefetch: true */ './en.json').then(translations => ({ en: translations })),
  de: () => import('./de.json').then(translations => ({ de: translations })),
  fr: () => import('./fr.json').then(translations => ({ fr: translations })),
  nl: () => import('./nl.json').then(translations => ({ nl: translations })),
};

export const rtiTranslations = {
  en: () =>
    import(
      /* webpackPrefetch: true */
      /* webpackChunkName: "en-json" */
      '@recruitee/integrations/locales/en.json'
    ).then(translations => ({
      en: translations.default,
    })),
  de: () =>
    import(
      /* webpackChunkName: "de-json" */
      '@recruitee/integrations/locales/de.json'
    ).then(translations => ({
      de: translations.default,
    })),
  fr: () =>
    import(
      /* webpackChunkName: "fr-json" */
      '@recruitee/integrations/locales/fr.json'
    ).then(translations => ({
      fr: translations.default,
    })),
  nl: () =>
    import(
      /* webpackChunkName: "nl-json" */
      '@recruitee/integrations/locales/nl.json'
    ).then(translations => ({
      nl: translations.default,
    })),
};
